<template>
   <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <div class="container-post">
            <div class="form-modal">
                <div> 
                    <div class="section-modal">
                        <button  class="close btn--close" @click="back()"></button>
                        <div class="wrapper">
                            <div>
                                <p style="font-weight: bold">Select Date</p>
                                <!-- <div class="date--picker">
                                    <p class="mg-btm-5">Start Date</p>
                                    <datepicker placeholder="Select Date" 
                                        v-model="start_date" 
                                        >
                                    </datepicker>
                                </div>
                                <div class="date--picker">
                                    <p class="mg-btm-5">End Date</p>
                                    <datepicker placeholder="Select Date" 
                                        v-model="end_date" 
                                        >
                                    </datepicker>
                                </div> -->
                                <date-picker class="mg-top1" v-model="eventDate" value-type="date" range type="datetime"></date-picker>
                            </div>
                            <div class="input-data mg-top">
                                <input type="text" required v-model="order_id">
                                <div class="underline"></div>
                                <label>Order Id</label>
                            </div>
                            <div class="input-data mg-top">
                                <input type="text" required v-model="doc_name">
                                <div class="underline"></div>
                                <label>Document Name</label>
                            </div>
                        </div>
                        <div class="dsp-flex mg-top1">
                            <input id="assetUpload" type="file" accept=".pdf , .doc , .xls , .xlsx , .text" @change="onAddFile($event)" hidden >
                            <button class="btn-upload mg-right" @click="chooseFiles()">Choose File</button>
                            <div> {{ filename }}</div>
                        </div>
                    </div>
                </div>        
                <div class="btn-heading">
                     <p class="mg-top" v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                        </ul>
                    </p>

                    <button class="btn-add mg-top1" @click="validation(id != 0 ? 'update' : 'add')">
                        <!-- Add Post -->
                        {{id != 0? 'Update' : 'Add'}} Post
                    </button>
                </div>     
            </div>
        </div>
    </div>
   </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import DatePicker from 'vue2-datepicker';
// import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import axios from 'axios';

import 'vue2-datepicker/index.css';

import auth from '@/service/auth.js'

export default {
    name: "DocumentForm",
    data() {
        return {
            showModal: false,
            isLoading: false,
            id: '',
            order_id: '',
            start_date: '',
            end_date: '',
            eventDate: [],
            doc_name: '',
            filename: '',
            file: null,
            errors: []
        }
    },
    methods: {
        validation(type) {
            this.errors = []
            
            if (!this.order_id) this.errors.push('* OrderId required')
            if (!this.doc_name) this.errors.push('* Document cannot be empty')
            if (!this.eventDate) this.errors.push('* Date required')
            // if (!this.end_date) this.errors.push('* End date required')
            if (!this.filename) this.errors.push('* File cannot be empty')
            

            if (this.errors.length > 0) {
                return
            } else if (type === 'add') {
                this.addPerindo()
            } else if (type === 'update') {
                this.updatePerindo()
            }
        },
        onAddFile (e) {
            console.log(e)
            this.file = e.target.files[0]
            this.filename = e.target.files[0].name
            console.log('assetUrl', this.file)
        },
        chooseFiles() {
            document.getElementById("assetUpload").click()
        },
        async addPerindo() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()
    
                    // let start_date = moment(this.start_date).format()
                    // let end_date = moment(this.end_date).format()

                    let start_date = moment(this.eventDate[0]).format()
                    let end_date = moment(this.eventDate[1]).format()
                    
                    formData.append('order_id', this.order_id)
                    formData.append('doc_name', this.doc_name)
                    formData.append('valid_start_date', start_date)
                    formData.append('valid_end_date', end_date)
                    formData.append('filename', this.file)
    
                    const response = await axios.post('/member/document', formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 201) {
                        alert.success('Add data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async getDataPerindo() { 
                let dataId = localStorage.getItem('dataPerindoById')
                
                let data = JSON.parse(dataId)

                this.order_id = data.order_id
                this.doc_name = data.doc_name
                this.filename = data.filename
                // this.start_date = data.valid_start_date
                // this.end_date = data.valid_end_date
                this.eventDate.push(new Date(data.valid_start_date))
                this.eventDate.push(new Date (data.valid_end_date))
        },
        async updatePerindo() {
            const res = await auth.checkAuth(this.$route.fullPath)
            if (res == false) {
                localStorage.clear()
                alert.failed('Unauthorized Token', () => this.$router.push('/login'))
            } else {
                try {
                    this.isLoading = true
                    const formData = new FormData()
    
                    // let start_date = moment(this.start_date).format()
                    // let end_date = moment(this.end_date).format()
                    let start_date = moment(this.eventDate[0]).format()
                    let end_date = moment(this.eventDate[1]).format()
    
                    formData.append('id', this.id)
                    formData.append('order_id', this.order_id)
                    formData.append('doc_name', this.doc_name)
                    formData.append('valid_start_date', start_date)
                    formData.append('valid_end_date', end_date)
                    formData.append('filename', this.file)
    
                    const response = await axios.patch(`/member/document/${this.id}`, formData)
                    this.isLoading = false
    
                    console.log(response)
                    if(response.status == 200) {
                        alert.success('Update data success', () => this.$router.go(-1))
                    }
    
                } catch (error) {
                    console.log(error)
                    this.isLoading = false
                    alert.failed('Update data failed')
                }
            }
        },
        back() {
            this.$router.go(-1)
        }
    },
    components: {
        // Datepicker,
        DatePicker,
        Loader
    },
    created() {
        this.id = this.$route.params.id
        if(this.id != 0) {
            this.getDataPerindo();
        }
    },
    
}
</script>